<template>
  <div class="text-xs-right grey--text body-2">
    <v-chip
      small
      v-if="!!projectId && showProject"
      @click="drawer = true"
      :color="$store.state.global.pages.project.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.project.icon}}</v-icon>
      </v-avatar>
      {{projectName}}
    </v-chip>

    <v-chip
      small
      v-if="!!siteId && showSite"
      @click="drawer = true"
      :color="$store.state.global.pages.site.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.site.icon}}</v-icon>
      </v-avatar>
      {{siteName}}
    </v-chip>

    <v-chip
      small
      v-if="!!selectedUserId && showUsers"
      @click="drawer = true"
      :color="$store.state.global.pages.user.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>{{$store.state.global.pages.user.icon}}</v-icon>
      </v-avatar>
      {{selectedUserName}}
    </v-chip>

    <v-chip
      small
      v-if="showBillingPeriod"
      @click="drawer = true"
      color="grey"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>calendar_today</v-icon>
      </v-avatar>
      {{!!billingPeriod ? billingPeriod : 'All Periods'}}
    </v-chip>

     <v-chip
      small
      v-if="billingStatus"
      @click="drawer = true"
      :color="$store.state.global.pages.billing.color"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>account_balance</v-icon>
      </v-avatar>
      {{billingStatus}}
    </v-chip>


    <v-chip
      small
      v-if="!!showClosed && showShowClosed"
      @click="drawer = true"
      color="indigo"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>check_circle_outline</v-icon>
      </v-avatar>Show Closed
    </v-chip>
    <v-chip
      small
      v-if="(!!dateRangeStart || !!dateRangeEnd) && showDateRange && !filterDate && showDateRangeToggle"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>date_range</v-icon>
      </v-avatar>
      {{!!dateRangeToggle ? 'Created At' : 'Date'}}
    </v-chip>
    <v-chip
      small
      v-if="(!!dateRangeStart || !!dateRangeEnd) && showDateRange && !filterDate && !useSingleDate"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>date_range</v-icon>
      </v-avatar>
      {{!!dateRangeStart ? makeShortDate(dateRangeStart) : ''}} - {{!!dateRangeEnd ? makeShortDate(dateRangeEnd) : ''}}
    </v-chip>
    <v-chip
      small
      v-if="(!!dateRangeStart || !!dateRangeEnd) && showDateRange && !filterDate && useSingleDate"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>date_range</v-icon>
      </v-avatar>
      {{!!dateRangeStart ? makeShortDate(dateRangeStart) : ''}}
    </v-chip>
    <v-chip
      small
      v-if="!!filterDate && showDate"
      @click="drawer = true"
      color="red"
      text-color="white"
      class="pointer"
    >
      <v-avatar style="margin-right: 0px">
        <v-icon>calendar_today</v-icon>
      </v-avatar>
      {{makeShortDate(filterDate)}}
    </v-chip>
  </div>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import GetNamesFromIds from '@/services/mixins/getNamesFromIds'
import FormatDates from '@/services/mixins/formatDates'
export default {
  mixins: [GetNamesFromIds, FormatDates],
  computed: {
    drawer: Store.getSet({ store: 'shared', prop: 'drawer' }),

    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    billingStatus: Store.getSet({ store: 'shared', prop: 'billingStatus' }),
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    dateRangeToggle: Store.getSet({ store: 'shared', prop: 'dateRangeToggle' }),
    useSingleDate: Store.getSet({ store: 'shared', prop: 'useSingleDate' }),
    projects: Store.getSet({ store: 'projects', prop: 'projects' }),
    sites: Store.getSet({ store: 'sites', prop: 'sites' }),
    users: Store.getSet({ store: 'users', prop: 'users' }),
    filterDate: Store.getSet({ store: 'allocations', prop: 'filterDate' }),

    showProject() {
      if (this.$route.name != 'rcti' && this.$route.name != 'billing') {
        return true
      } else {
        return false
      }
    },
    showSite() {
      if (
        this.$route.name == 'docket' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'allocationStaging'
      ) {
        return true
      } else {
        return false
      }
    },
    showBillingPeriod() {
      if (
        this.$route.name != 'rate' &&
        this.$route.name != 'allocationStaging' &&
        this.$route.name != 'allocation' &&
        this.$route.name != 'tipping'
      ) {
        return true
      } else {
        return false
      }
    },
    showShowClosed() {
      if (
        this.$route.name == 'docket' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'approvedBillLine' ||
        this.$route.name == 'tipping'
      ) {
        return true
      } else {
        return false
      }
    },
    showUsers() {
      if (
        this.$route.name == 'docket' ||
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'tipping'
      ) {
        return true
      } else {
        return false
      }
    },
    showDateRange() {
      if (
        this.$route.name == 'allocationStaging' ||
        this.$route.name == 'allocation' ||
        this.$route.name == 'tipping' ||
        this.$route.name == 'docket'
      ) {
        return true
      } else {
        return false
      }
    },
    showDateRangeToggle() {
      return this.$route.name == 'tipping' ? true : false
    },
    showDate() {
      if (this.$route.name == 'allocation') return true
      return false
    }
  }
}
</script>

<style>
.v-chip .v-chip__content {
  cursor: pointer;
}
</style>
